module.exports = __webpack_public_path__ + "img/Billboard2.a773bdb0.jpg";